module.exports = __webpack_public_path__ + "media/finish_1.ec60893c.wav";